import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild,
  Input,
  OnChanges,
  OnDestroy,
} from "@angular/core";
import MetisMenu from "metismenujs";
import { EventService } from "../../core/services/event.service";
import { Router, NavigationEnd } from "@angular/router";

import { TranslateService } from "@ngx-translate/core";

import { Subject, takeUntil } from "rxjs";
import { AuthService } from "src/app/core/services/auth.service";

import { MENU_ADMIN, MENU_CLIENTE } from "./menu";
import { MenuItem } from "./menu.model";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy
{
  @ViewChild("componentRef") scrollRef: any;
  @Input() isCondensed = false;
  menu: any;

  menuItems: MenuItem[] = [];

  @ViewChild("sideMenu") sideMenu!: ElementRef;

  private destroy$ = new Subject<void>();

  constructor(
    private eventService: EventService,
    private router: Router,
    public translate: TranslateService,
    private auth: AuthService,
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
        this._scrollElement();
      }
    });
  }

  ngOnInit() {
    // ✅ setea menú según rol (y reacciona a cambios de usuario)
    this.auth.user$.pipe(takeUntil(this.destroy$)).subscribe((u) => {
      const role = u?.role ?? null;
      this.menuItems = role === "CLIENTE" ? MENU_CLIENTE : MENU_ADMIN;

      // ✅ re-render metismenu cuando cambia el menú
      setTimeout(() => {
        if (this.sideMenu?.nativeElement) {
          if (this.menu) this.menu.dispose();
          this.menu = new MetisMenu(this.sideMenu.nativeElement);
          this._activateMenuDropdown();
          this._scrollElement();
        }
      }, 0);
    });

    this._scrollElement();
  }

  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);
    this._activateMenuDropdown();
  }

  ngOnChanges() {
    if ((!this.isCondensed && this.sideMenu) || this.isCondensed) {
      setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.menu) this.menu.dispose();
  }

  toggleMenu(event: any) {
    event.currentTarget.nextElementSibling.classList.toggle("mm-show");
  }

  _scrollElement() {
    setTimeout(() => {
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition = (
          document.getElementsByClassName("mm-active")[0] as any
        )["offsetTop"];
        if (currentPosition > 500)
          if (this.scrollRef?.SimpleBar !== null)
            this.scrollRef.SimpleBar.getScrollElement().scrollTop =
              currentPosition + 300;
      }
    }, 300);
  }

  _removeAllClass(className: string) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  _activateMenuDropdown() {
    this._removeAllClass("mm-active");
    this._removeAllClass("mm-show");

    const links = document.getElementsByClassName("side-nav-link-ref");
    let menuItemEl: any = null;

    const paths: string[] = [];
    for (let i = 0; i < links.length; i++) {
      paths.push((links[i] as any)["pathname"]);
    }

    const itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf("/");
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }

    if (menuItemEl) {
      menuItemEl.classList.add("active");
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add("mm-active");
        const parent2El = parentEl.parentElement.closest("ul");
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.add("mm-show");
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== "side-menu") {
            parent3El.classList.add("mm-active");
            const childAnchor = parent3El.querySelector(".has-arrow");
            const childDropdown = parent3El.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");

            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== "side-menu") {
              parent4El.classList.add("mm-show");
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== "side-menu") {
                parent5El.classList.add("mm-active");
                const childanchor = parent5El.querySelector(".is-parent");
                if (childanchor && parent5El.id !== "side-menu") {
                  childanchor.classList.add("mm-active");
                }
              }
            }
          }
        }
      }
    }
  }

  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }
}
